var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "web-chat" } }, [
    _c(
      "div",
      { staticClass: "route-page-content" },
      [
        _c("WebChatMenu", {
          model: {
            value: _vm.selectedTab,
            callback: function ($$v) {
              _vm.selectedTab = $$v
            },
            expression: "selectedTab",
          },
        }),
        _vm._v(" "),
        _vm.settingInitialized
          ? _c(
              "div",
              { staticClass: "page-content-wrapper" },
              [
                _vm.isSelected("bubble-actions")
                  ? _c("BubbleActions", {
                      attrs: { "update-settings": _vm.updateSingleSettings },
                    })
                  : _vm.isSelected("bubble-settings")
                  ? _c("BubbleSettings", {
                      attrs: { "update-settings": _vm.updateSingleSettings },
                    })
                  : _vm.isSelected("theme-settings")
                  ? _c("ChatThemeSettings", {
                      attrs: { "update-settings": _vm.updateSingleSettings },
                    })
                  : _vm.isSelected("talk-settings")
                  ? _c("TalkSettings", {
                      attrs: { "update-settings": _vm.updateSingleSettings },
                    })
                  : _vm.isSelected("visitor-login-form")
                  ? _c("VisitorLoginForm", {
                      attrs: { "update-settings": _vm.updateSingleSettings },
                    })
                  : _vm.isSelected("catalog")
                  ? _c("Catalog")
                  : _vm.isSelected("triggers")
                  ? _c("Triggers")
                  : _vm.isSelected("details")
                  ? _c("Details", {
                      attrs: { "update-settings": _vm.updateSingleSettings },
                    })
                  : _vm.isSelected("website-integration")
                  ? _c("WebSiteIntegration")
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }